import React, { Component, useState, useEffect, useMemo, useRef } from 'react';
import { List, Accordion } from 'devextreme-react';
import * as Fnctn from '../../contexts/GenericFunctions';
import DropDownButton from 'devextreme-react/drop-down-button';
import { ItemDragging } from 'devextreme-react/list';
import { TextBox, Button, Popup } from 'devextreme-react';
import notify from 'devextreme/ui/notify';
import { halcoloaderActive, halcoloaderRemove } from '../../contexts/HalcoLoader'
import * as FireBase from '../../contexts/FirebaseActions'
import { Audiencia } from '../../components/Tasks/componentTasks'
import "bootstrap/dist/css/bootstrap.min.css";
import '../NuevoCurso/NuevoCurso.scss'

let segmentacion: any = {
    areas: [],
    branches: [],
    companies: [],
    type_collaborators: []
};

function EditarCursos() {
    const [Courses, setCourses] = useState<any>(undefined)
    const [Classes, setClasses] = useState<any[]>([])
    const [visibleEditCurso, setvisibleEditCurso] = useState<boolean>(false)
    const [valueTitulo, setvalueTitulo] = useState<string>("")
    const [segmentation, setSegmentation] = useState<{ [key: string]: [] }>()
    const [idTitulo, setidTitulo] = useState<string>("")
    const [newTitulo, setnewTitulo] = useState<string>("")
    const [fotoCurso, setfotoCurso] = useState<string>("")
    const [nombreFotoCurso, setnombreFotoCurso] = useState<string>("")
    const [inputRef, setinputRef] = useState<any>(React.createRef)
    const [file, setfile] = useState<any>(null)
    const [changefile, setchangefile] = useState<any>(false)
    const [Show_confirm_DeleteCourse, setShow_confirm_DeleteCourse] = useState<boolean>(false)
    const [Show_confirm_UnassignCourse, setShow_confirm_UnassignCourse] = useState<boolean>(false)
    const [dtArea] = useState<any>([]);
    const [dtEmpresa] = useState<any>([]);
    const [dtSucursal] = useState<any>([]);
    const editorCursoRef = useRef<HTMLDivElement>(null);


    const ItemsMenu = [
        { id: 1, name: 'Editar tarea', icon: 'edit' },
        { id: 2, name: 'Eliminar tarea', icon: 'close' }
    ];

    const itemsAccordion = [
        { title: 'Area', Codigo: "areas" },
        { title: 'Sucursal', Codigo: 'branches' },
        { title: 'Empresa', Codigo: 'companies' }
    ];

    useEffect(() => {
        getCourses()
    }, []);

    const getCourses = async () => {
        try {
            halcoloaderActive();
            const dtresult = await Fnctn.postData(`/catalogs/courses/?onboarding=false`, "GET", {});
            const dtCourse = await dtresult.json();
            const sortedItems = [...dtCourse.data[0]].sort((a, b) => a.order - b.order);
            setCourses(sortedItems);
            halcoloaderRemove();
        }
        catch (error) {
            notify(error, "error");
        }
    }

    const ItemRenderAccordion = (item: any) => {
        return (
            <div className='listCategoriesContent'>
                <img src={item.img_path} className='ImgCategories' alt='img' />
                <label className='lbTitleCategories'>{item.name}</label>
            </div>
        )
    }

    const getClasses = async (items: any) => {
        try {
            halcoloaderActive();
            setClasses([]);
            const dtresult = await Fnctn.postData(`/training/Task`, "GET", {});
            const dtCourses = await dtresult.json();
            const DataCourses = dtCourses.data.filter((item: any) => item.category_id === items.itemData._id);
            setClasses(DataCourses);
            halcoloaderRemove();
        }
        catch (error) {
            notify(error, "error");
        }
    }

    const onItemClick = (opcion: string, id_task: string) => {
    };

    const OpcionesRender = (e: any) => {
        const icon = `dx-icon dx-icon-${e.icon}`;
        return (
            <div style={{ width: "0rem", height: "0rem" }}>
                <i className={icon} style={{ fontSize: "20px" }}></i>
                <label style={{ margin: "auto auto auto 1rem" }}>{e.name}</label>
            </div>
        )
    }


    const itemRenderdtList = (item: any) => {
        return (
            <div className='listCoursesContent'>
                <img src={item.icon_path} className='ImgCourses' alt='Img' />
                <label className='lbTitleCourses'>{item.title}</label>
                <DropDownButton
                    className='menuCourses'
                    splitButton={false}
                    useSelectMode={false}
                    icon="overflow"
                    text='Opciones'
                    showArrowIcon={false}
                    items={ItemsMenu}
                    displayExpr="name"
                    keyExpr="id"
                    dropDownOptions={{ width: "10rem" }}
                    onItemClick={(e) => onItemClick(e.itemData.id, item._id)}
                    itemRender={OpcionesRender}
                />
            </div>
        )
    }

    const ItemRender = () => {
        return (
            <div>
                <List
                    dataSource={Classes}
                    height={400}
                    selectionMode={"none"}
                    displayExpr={"name"}
                    keyExpr={"_id"}
                    itemRender={itemRenderdtList}
                ></List>
            </div>
        )
    }

    const deleteCourses = async (e: any) => {
        try {
            setShow_confirm_DeleteCourse(true);
            const element = e.itemData._id;
            setidTitulo(element);
        }
        catch (error) {
            notify(error, "error");
        }
    }

    const onDragStart = (e: any) => {
        e.itemData = Courses[e.fromIndex]
    }

    const onAdd = async (e: any) => {

        const courses = Courses
        const updatedCourses = [...courses.slice(0, e.toIndex), e.itemData, ...courses.slice(e.toIndex)];

        for (let i: number = 0; i < updatedCourses.length; i++) {
            updatedCourses[i].order = i;
        }

        updatedCourses.forEach(async (element: any) => {
            let Objt = { "order": element.order }

            await Fnctn.postData(`/catalogs/courses/${element._id}`, 'PUT', Objt);
        });
        setCourses(updatedCourses);
    }

    const onRemove = async (e: any) => {
        const tasks = Courses;
        const updatedCourses = [...tasks.slice(0, e.fromIndex), ...tasks.slice(e.fromIndex + 1)];
        setCourses(updatedCourses);
    }

    const onReorder = async (e: any) => {
        await onRemove(e);
        await onAdd(e);
    }

    const itemClick = (e: any) => {
        setvisibleEditCurso(true);
        setvalueTitulo(e.itemData.name);
        setnewTitulo(e.itemData.name);
        setidTitulo(e.itemData._id);
        setfotoCurso(e.itemData.img_path);
        setnombreFotoCurso(e.itemData.img_name);
        setSegmentation(e.itemData.segmentation);
        segmentacion = e.itemData.segmentation;

        setTimeout(() => {
            editorCursoRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
    }

    const ChangeTiutlo = (e: any) => {
        setnewTitulo(e.value);
        setvalueTitulo(e.value);
    }

    const Cancelar = () => {
        setvisibleEditCurso(false);
        setvalueTitulo("");
        setidTitulo("");
        setchangefile(false);
    }

    const Guardar = async () => {
        if (!Fnctn.NullUndefinedEmpty(newTitulo)) {
            let assignated = false;

            if (segmentacion.areas.length > 0 || segmentacion.branches.length > 0 || segmentacion.companies.length > 0) {
                assignated = true;
            }
            else {
                assignated = false;
            }

            let Objt: any = {
                "name": newTitulo,
                "segmentation": segmentacion,
                "assignated": assignated
            }

            if (changefile) {
                let IconoTarea: any = await FireBase.DeleteFile(nombreFotoCurso, FireBase.enumPath.ICONOS_CATEGORIAS);
                IconoTarea = await FireBase.uploadFile(file, FireBase.enumPath.ICONOS_CATEGORIAS);
                Objt.img_path = IconoTarea.PathFireBase
                Objt.img_name = IconoTarea.NameFirebase
            }

            const dtresult = await Fnctn.postData(`/catalogs/courses/${idTitulo}`, 'PUT', Objt);

            let result: any = await dtresult.json();
            setchangefile(false);
            notify("Nombre actualizado correctamente", "success");
        }
        else {
            notify("Debes ingresar un título a el curso", "error");
        }

        Cancelar();
        getCourses();
    }

    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files && event.target.files[0];
        setfile(file);
        setchangefile(true);
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String: string = reader.result!.toString();
                setfotoCurso(base64String);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleClick = () => {
        if (inputRef.current) {
            setchangefile(true);
            inputRef.current.click();
        }
    };

    const ConfirmDeleteCourse = async (id: string) => {
        let api = Fnctn.GetAPI();
        const data = Fnctn.getCookie();

        let Objt = { "active": false }

        const dtresult = await fetch(`${api}/catalogs/categories/${id}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${data.token}`
            },
            body: JSON.stringify(Objt)
        });
        await dtresult.json();
        setShow_confirm_DeleteCourse(false)
    }
    const getIds = (ids: any, list: string) => {
        if (list === "areas") {
            segmentacion.areas = ids
        }
        else if (list === "branches") {
            segmentacion.branches = ids
        }
        else if (list === "companies") {
            segmentacion.companies = ids
        }
    };

    const QuitarAsignacion = () => {
        setShow_confirm_UnassignCourse(true);
    }

    const ConfirmUnassignCourse = async (id: string) => {
        try {
            const dtresult = await Fnctn.postData(`/catalogs/unassignCourse/${id}`, "GET", {});
            console.log(await dtresult.json());
            setShow_confirm_UnassignCourse(false);
            getCourses();
        }
        catch (error) {
            notify(error, "error");
        }
    }

    const itemRenderAccordionSegmentation = useMemo(() => (itemData: any, segmentation: any) => {
        return (
            <Audiencia props={itemData} selectedItems={segmentation} getIds={getIds}></Audiencia>
        )
    }, [dtArea.data, dtSucursal.data, dtEmpresa.data]);

    // render() {
    return (
        <div className='windowPrincipal'>
            <div className='window1'>
                <div style={{ margin: '1rem auto 2rem 1rem', color: "#172b4d" }}>
                    <label style={{ fontSize: "1.3rem", margin: "auto auto auto 15px" }}>Cursos</label>
                </div>
                <List
                    className='AccordionCourses'
                    dataSource={Courses}
                    keyExpr={"_id"}
                    displayExpr={"name"}
                    itemRender={(e) => ItemRenderAccordion(e)}
                    allowItemDeleting={true}
                    itemDeleteMode={"static"}
                    onItemDeleted={(e) => deleteCourses(e)}
                    searchExpr="name"
                    searchEnabled={true}
                    searchMode={'contains'}
                    onItemClick={((e) => itemClick(e))}
                >
                    <ItemDragging
                        allowReordering={true}
                        onDragStart={(e) => onDragStart(e)}
                        onAdd={(e) => onAdd(e)}
                        onRemove={(e) => onRemove(e)}
                        onReorder={(e) => onReorder(e)}
                    ></ItemDragging>
                </List>
            </div>
            {visibleEditCurso &&
                <>
                    <div ref={editorCursoRef} className='row d-flex justify-content-center EditorCurso' style={{ margin: "5% 0% 5% 3%", height: "25%" }}>
                        <div className={'row'} style={{ borderRadius: '10%' }} >
                            <div className='row d-flex justify-content-center'>
                                <div className='col-md-6'>
                                    <img
                                        alt={''}
                                        className='ImgEditCurso'
                                        src={fotoCurso}
                                        style={{ cursor: 'pointer' }}
                                        onClick={handleClick}
                                    />
                                </div>
                            </div>
                            <input
                                ref={inputRef}
                                type="file"
                                accept="image/*"
                                onChange={handleFileUpload}
                                style={{ display: 'none' }}
                            />
                        </div>
                        <div className={'row'} style={{ margin: "5% 0% 0% 0%" }}>
                            <TextBox
                                visible={true}
                                className='TituloCurso'
                                label='Titulo'
                                value={valueTitulo}
                                onValueChanged={(e) => ChangeTiutlo(e)}
                                height={"10%"}
                                width={"90%"}
                            />
                            <Accordion
                                dataSource={itemsAccordion}
                                animationDuration={500}
                                itemRender={(e) => itemRenderAccordionSegmentation(e, segmentation)}
                                id="accordion-container"
                                style={{ margin: "2% 0% 0% 3%", width: "90%" }}
                            />
                        </div>
                        <div className={'row'}>
                            <div className='row' style={{ margin: "5% 0% 3% 0%" }}>
                                <div className='col-4'>
                                    <Button className='GuardarCuro' width={"100%"} onClick={() => Guardar()}>Guardar</Button>
                                </div>
                                <div className='col-4'>{/*Mandar update y ya*/}
                                    <Button className='CancelarCurso' width={"100%"} onClick={() => Cancelar()}>Cancelar</Button>
                                </div>
                                <div className='col-4'>{/*Mandar update y ya*/}
                                    <Button className='QuitarAsignacion' width={"100%"} onClick={() => QuitarAsignacion()}>Quitar Asignación</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
            <Popup
                visible={Show_confirm_DeleteCourse}
                dragEnabled={false}
                hideOnOutsideClick={true}
                onHiding={() => setShow_confirm_DeleteCourse(false)}
                showCloseButton={false}
                showTitle={false}
                width={'auto'}
                height={'auto'}
            >
                <div style={{ justifyContent: 'center' }} >
                    <div className='row d-flex justify-content-center' style={{ margin: "0rem 0rem 1rem 0rem" }} >
                        <label style={{ fontWeight: 'bold', fontSize: 18, width: '100%' }}>¿Quieres eliminar la catergoria?</label><br />
                    </div>
                    <div className='row d-flex justify-content-center'>
                        <div className='col-md-6'>
                            <Button style={{ width: "100%" }} className='btnAceptar' onClick={() => ConfirmDeleteCourse(idTitulo)}><label style={{ fontWeight: 'bold', fontSize: 13 }}>Aceptar</label></Button>
                        </div>
                        <div className='col-md-6'>
                            <Button style={{ width: "100%" }} className='btnCancelar' onClick={() => setShow_confirm_DeleteCourse(false)}><label style={{ fontWeight: 'bold', fontSize: 13 }}>Cancelar</label></Button>
                        </div>
                    </div>
                </div>
            </Popup>
            <Popup
                visible={Show_confirm_UnassignCourse}
                dragEnabled={false}
                hideOnOutsideClick={true}
                onHiding={() => setShow_confirm_UnassignCourse(false)}
                showCloseButton={false}
                showTitle={false}
                width={'auto'}
                height={'auto'}
            >
                <div className='row d-flex justify-content-center' style={{ margin: "0rem 0rem 1rem 0rem" }} >
                    <label style={{ fontWeight: 'bold', fontSize: 18, width: '100%' }}>¿Quieres desasignar el curso para todos?</label><br />
                </div>
                <div className='row d-flex justify-content-center'>
                    <div className='col-md-6'>
                        <Button style={{ width: "90%" }} className='btnAceptar' onClick={() => ConfirmUnassignCourse(idTitulo)}><label style={{ fontWeight: 'bold', fontSize: 13 }}>Aceptar</label></Button>
                    </div>
                    <div className='col-md-6'>
                        <Button style={{ width: "90%" }} className='btnCancelar' onClick={() => setShow_confirm_UnassignCourse(false)}><label style={{ fontWeight: 'bold', fontSize: 13 }}>Cancelar</label></Button>
                    </div>
                </div>
            </Popup>
        </div>
    );
    // }
}

export default EditarCursos;
